
function change(element) {
  element.forEach((el) => {
    if (el.classList.contains('shown-image')) {
      el.classList.remove('shown-image');
      el.classList.add('hidden-image');
    } else {
      el.classList.remove('hidden-image');
      el.classList.add('shown-image');
    }
  });
}

let textBlock = document.querySelector('.animate-image');
let pargraph = textBlock.querySelectorAll('IMG');

let count = 1000;
let ms = 5000;
let i = 0;

function getImage() {
  change(pargraph);
  i += 1;
  setTimeout(function () {
    if (i < count) {
      getImage();
    }
  }, ms);
}

export {getImage};
